/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {
  CHANNELS_PUBLISHING_STATE_FETCHING,
  CHANNELS_PUBLISHING_STATE_DONE,
  CHANNELS_PUBLISHING_STATE_ERROR,
  ChannelsPublishingActions
} from 'store/action/channels-publishing';

export interface IChannelsPublishingState {
  publishingState: {channelId: string; isOnline: boolean; multipleStreams: boolean}[];
  isFetching: boolean;
  error: null | string;
}

const initialChannelsPublishingState: IChannelsPublishingState = {
  publishingState: [],
  isFetching: false,
  error: null
};
const channelsPublishingReducer: Reducer<
  Readonly<IChannelsPublishingState>,
  ChannelsPublishingActions
> = (
  state: IChannelsPublishingState = initialChannelsPublishingState,
  action: ChannelsPublishingActions
) => {
  switch (action.type) {
    case CHANNELS_PUBLISHING_STATE_FETCHING: {
      return {
        ...state,
        isFetching: true
      };
    }

    case CHANNELS_PUBLISHING_STATE_DONE: {
      return {
        ...state,
        isFetching: false,
        publishingState: action.payload
      };
    }

    case CHANNELS_PUBLISHING_STATE_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    default:
      return state;
  }
};

export default channelsPublishingReducer;